export default "__VITE_ASSET__RfdO5QZZ__"